exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty{padding:20px;margin:10px auto;display:flex;flex-direction:column;align-items:center;border-radius:5px;color:var(--light-black)}.empty__message{margin-top:5px;text-align:center;font-size:var(--font-small)}.empty--background__icon{width:50px}", ""]);

// exports
